import { Injectable, Inject, InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable, from, defer } from 'rxjs';
import { environment } from '@environments/environment';
import { APP_BASE_HREF } from '@angular/common';
import { customWrapper} from 'src/assets/custom.js' 
import { WebStorageService } from './_core/services/webstorage.service';
import { WindowsWrapperService } from './_core/services/windows-wrapper.service';
@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    private config: any;
    private openedTabs: { baseUrl: string, tab: Window | null }[] = [];

    constructor(
        private http: HttpClient, 
        @Inject(APP_BASE_HREF) 
        public baseHref: string,
        private webStorageService: WebStorageService,
        private WindowsWrapper: WindowsWrapperService,
    ) { }

    loadConfig(): Observable<any> {
        return this.http.get(this.baseHref + '/assets/config.json');
    }

    getConfig(): any {
        return this.config;
    }

    setConfig(config: any): void {
        this.config = config;
    }

    geturl(companyCode: string): string {
        let url = "";
        companyCode = companyCode.toUpperCase();
        let env = environment.production ? 'Prod' : 'Stage'
        if (companyCode in this.config && env in this.config[companyCode]) {
            url = this.config[companyCode][env]['Url']
        }
        return url
    }

    OpenUrlInNewTab(url: string) {
        if (!url || url.trim() === '') {
            return;
        }
        const urlObj = new URL(url);
        const baseUrl = `${urlObj.protocol}//${urlObj.host}`;
        this.openedTabs = this.openedTabs.filter(tab => tab.tab && !tab.tab.closed);
        const existingTab = this.openedTabs.find(tab => tab.baseUrl === baseUrl);
        
        if (!existingTab) {

            const allowPopUps = this.webStorageService.getItemFromSessionStorage('loginParams')?.AllowPopUps ?? true;

            const newTab = allowPopUps ? window.open(url, '_blank') : null;

            if(!this.WindowsWrapper.IsWrapper()){
                if (newTab) {
                    this.openedTabs.push({ baseUrl, tab: newTab });
                } else {
                    console.error('Failed to open a new tab. The browser might have blocked it.');
                }
            }
        } else {

            existingTab.tab.location.href = url;
            existingTab.tab.focus();
        }
    }


    async readFileContent(relFilePath) {
        return await firstValueFrom(this.http.get(this.baseHref + relFilePath));
    }
    // async readFieldsConfigSample(relFilePath)
    // {
    //   return await firstValueFrom(this.http.get(this.baseHref +relFilePath));
    // }
    // async readSampleResponse(relFilePath)
    // {
    //   return await firstValueFrom(this.http.get(this.baseHref +relFilePath));
    // } 
      loadWrapper(): Observable<any> { 
          const myNiceObservable = from(this.getWrapperConfig());
          //console.log('caasasas', myNiceObservable);
          return myNiceObservable;
    }
    getWrapperConfig(): Promise<any> {
        let promise;
        if ('CefSharp' in window) {
            promise = new Promise(function (resolve, reject) {
                window['CefSharp'].BindObjectAsync({ NotifyIfAlreadyBound: true, IgnoreCache: true }).then(function (result) {
                    //console.log(result);
                    resolve(window['onvidaWrapper']);
                });
            });

        } else {
            promise = Promise.resolve(null);
        }
        return promise; 
    }
}